import React from 'react'
import { Link} from "react-router-dom"
import { toast } from "react-toastify";
import TypeWriterEffect from 'react-typewriter-effect';

export const CambiarEnglish = ({title,message,cambio}) => {
  const handleAnimation = () => {
    toast.success(`${message}`)
  }
  return(
    <button >
        <Link to={`${cambio}`} onClick={() => handleAnimation()} className='text-emerald-300'>{title}</Link>
    </button>
  )
}

const Home = () => {
   
  return (
    <div className=' flex w-full h-screen justify-center flex items-center text-gray-300'>

        <div className=' xl:w-8/12 md:10/12 lg:w-10/12 m-auto '>
          <h1 className='text-emerald-300 text-lg'>¡Hola!, mi nombre es</h1>
          <div>
            <h4 className='md:text-7xl text-3xl sm:text-4xl mt-5'>Yeremi Araya.</h4>
            <div className='flex text-gray-400 mr-2 mt-4 text-xl xl:text-5xl 2xl:text-7xl'>
              <h4 className='mr-4'>Desarrollo 
             
              </h4>
              <TypeWriterEffect
               textStyle={{
                fontFamily: 'Red Hat Display',
                color: '#3F3D56',
              }}
              startDelay={2000}
              cursorColor="#3F3D56"
              multiText={[
                'sitios web Fullstack',
                'aplicaciones moviles',
                'sitios web Fullstack',
                'aplicaciones moviles',
                'sitios web Fullstack',
                'sitios web Fullstack',
                'aplicaciones moviles',
                'sitios web Fullstack',
                'aplicaciones moviles',
                'sitios web Fullstack',
                'sitios web Fullstack',
                'aplicaciones moviles',
                'sitios web Fullstack',
                'aplicaciones moviles',
                'sitios web Fullstack'
              ]}
              multiTextDelay={1000}
              typeSpeed={30}/>
            </div>
            
          </div>
          <div className='mt-6'>
            <p className='text-gray-500'>Soy un programador autodidacta, apasionado por aprender <br/> constantemente y crear soluciones óptimas y de una alta calidad.<br/>
            Actualmente, estoy en busca de nuevos desafíos que me ayuden <br/>a crecer como programador</p>
          <div className='mt-6 border hover:bg-emerald-900 py-2 px-2 w-20 rounded border-emerald-300 border-2'>
             <CambiarEnglish message={'The page has changed to English'} cambio={'/en'} title={'English'}/>
            {/*<Link to="/en" className='text-emerald-300'>English</Link> */}
            
          </div>
          </div>
      </div> 
    </div>
  )
}

export default Home